import { Route } from 'react-router-dom';
import { lazyWithRetry } from 'components/lazyWithRetry';

const ComponentList = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields'));
const DynamicRegistrationFlow = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicRegistrationFlow'));
const ConfigureDynamicRegistrationFlow = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicRegistrationFlow/ConfigureDynamicRegistrationFlow'));
const WelcomeMessage = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicRegistrationFlow/WelcomeMessage'));
const BackgroundImage = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicRegistrationFlow/BackgroundImage'));
const RegistrationUrl = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicRegistrationFlow/RegistrationUrl'));
const Applicants = lazyWithRetry(() => import('modules/admin/applicantRegistration/applicants'));
const VettingPool = lazyWithRetry(() => import('modules/admin/applicantRegistration/vettingPool'));

const RegistrationForm = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields/RegistrationForm'));
const Notification = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields/Notification'));
const ProfileEnrollment = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields/ProfileEnrollment'));
const VideoInterview = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields/VideoInterview'));
const DocumentUploads = lazyWithRetry(() => import('modules/admin/applicantRegistration/dynamicFields/DocumentUploads'));
const ApplicantDetail = lazyWithRetry(() => import('modules/admin/applicantRegistration/applicants/ApplicantDetail'));

export default (
  <>
    <Route
      path="applicant-registration/dynamic-fields"
      element={<ComponentList />}
    />
    <Route
      path="applicant-registration/dynamic-registration-flow"
      element={<DynamicRegistrationFlow />}
    />
    <Route
      path="applicant-registration/dynamic-registration-flow/configure-dynamic-registration-flow/:id"
      element={<ConfigureDynamicRegistrationFlow />}
    />
    <Route
      path="applicant-registration/dynamic-registration-flow/configure-dynamic-registration-flow/welcome-message/:id"
      element={<WelcomeMessage />}
    />
    <Route
      path="applicant-registration/dynamic-registration-flow/configure-dynamic-registration-flow/background-image/:id"
      element={<BackgroundImage />}
    />
    <Route
      path="applicant-registration/dynamic-registration-flow/configure-dynamic-registration-flow/registration-url/:id"
      element={<RegistrationUrl />}
    />
    {/* registration form */}
    <Route
      path="applicant-registration/dynamic-fields/registration-form/:id"
      element={<RegistrationForm />}
    />
    <Route
      path="applicant-registration/dynamic-fields/registration-form/:id/view"
      element={<RegistrationForm />}
    />
    {/* notification */}
    <Route
      path="applicant-registration/dynamic-fields/notification/:id"
      element={<Notification />}
    />
    <Route
      path="applicant-registration/dynamic-fields/notification/:id/view"
      element={<Notification />}
    />
    {/* profile enrollment */}
    <Route
      path="applicant-registration/dynamic-fields/profile-enrollment/:id"
      element={<ProfileEnrollment />}
    />{' '}
    <Route
      path="applicant-registration/dynamic-fields/profile-enrollment/:id/view"
      element={<ProfileEnrollment />}
    />
    {/* video interview */}
    <Route
      path="applicant-registration/dynamic-fields/video-interview/:id"
      element={<VideoInterview />}
    />
    <Route
      path="applicant-registration/dynamic-fields/video-interview/:id/edit"
      element={<VideoInterview />}
    />{' '}
    <Route
      path="applicant-registration/dynamic-fields/video-interview/:id/view"
      element={<VideoInterview />}
    />
    {/* document uploads */}
    <Route
      path="applicant-registration/dynamic-fields/document-uploads/:id"
      element={<DocumentUploads />}
    />
    <Route
      path="applicant-registration/dynamic-fields/document-uploads/:id/edit"
      element={<DocumentUploads />}
    />
    <Route
      path="applicant-registration/dynamic-fields/document-uploads/:id/view"
      element={<DocumentUploads />}
    />
    <Route
      path="applicant-registration/applicants"
      element={<Applicants />}
    />
    <Route
      path="applicant-registration/applicants/applicants-details/:id"
      element={<ApplicantDetail />}
    />
    <Route
      path="applicant-registration/vetting-pool"
      element={<VettingPool />}
    />
  </>
);
